import type * as React from 'react';

import type { InlineProps } from '@gitbook/slate-react';

/*
 * Basic renderer for an inline link
 */
export function BasicInlineLink(props: InlineProps): React.ReactElement {
    const { node, children, attributes } = props;
    const linkRef = node.data.get('ref');

    return (
        <a
            {...attributes}
            href={linkRef.url}
            className="text-link-low underline hover:no-underline"
        >
            {children}
        </a>
    );
}
